import { ProductComponent } from "../../types/productComponent";

export function findProductComponent(
    productComponents: ProductComponent[],
    productComponentId: string
): ProductComponent | undefined {
    return productComponents.find((productComponent) => productComponent.id === productComponentId);
}
